<mat-slide-toggle
	[checked]="checked"
	[disabled]="disabled"
	[color]="color"
	[name]="name"
	[hideIcon]="hideIcon"
	[labelPosition]="labelPosition"
	[disableRipple]="disableRipple"
	[required]="required"
	[aria-label]="ariaLabel"
	(change)="onInnerChange($event)">
	<ng-content></ng-content>
</mat-slide-toggle>
